// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderUploadErrorsModalStyles } from "@hardwoods/Overrides/Components/OrderUploadErrorsModal";
import { iconButtonCommonStyles } from "@hardwoods/XDL/Utilities/iconButtonCommonStyles";
import { xScreen } from "@hardwoods/XDL/Utilities/MediaQuery";
import Export from "@insite/mobius/Icons/Share";
import { css } from "styled-components";

orderUploadErrorsModalStyles.pdfButton = {
    ...iconButtonCommonStyles(Export, { sizeVariant: "small" }),
};

orderUploadErrorsModalStyles.bottomWrapper = {
    css: css`
        &&& {
            margin-top: 30px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            width: 100%;

            ${xScreen.lte("xs")} {
                flex-direction: column;
            }
        }
    `,
};

orderUploadErrorsModalStyles.buttonsWrapper = {
    css: css`
        margin-top: 0;
        text-align: right;
    `,
};
